"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uuid = require("uuid");

var _uuid2 = _interopRequireDefault(_uuid);

var _Avatar = require("../Avatar");

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Icon = require("../../Icon/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _RawButton = require("../../RawButton/RawButton");

var _RawButton2 = _interopRequireDefault(_RawButton);

var _Button = require("../../Button/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comment = function (_Component) {
  _inherits(Comment, _Component);

  function Comment(props) {
    _classCallCheck(this, Comment);

    var _this = _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).call(this, props));

    _this.onTransitionEnded = function (event) {
      // will pass if it's delete action
      var classList = event.currentTarget.classList;
      var isDelete = classList.contains(_this.isDeleteStateClassName.replace(" ", ""));
      _this.props.onTransitionEnded(event, isDelete);
    };

    _this.rootElementRendered = function ($element) {
      if ($element) {
        _this.$message = $element;
        // please review if this works in IE, Safari, Firefox and Chrome
        _this.$message.addEventListener("transitionend", _this.onTransitionEnded, false);

        if (_this.props.isNewAddedState) {
          setTimeout(function () {
            $element.classList.remove(_this.isNewAddedStateClassName.replace(" ", ""));
          }, 100);
        }
      }
    };

    _this.$message = null;
    _this.state = {
      showConfirmation: false
    };

    _this.isNewAddedStateClassName = "aclui-comment--is-added";
    _this.isDeleteStateClassName = "aclui-comment--is-deleted";
    return _this;
  }

  _createClass(Comment, [{
    key: "handleOnDelete",
    value: function handleOnDelete() {
      this.props.onDelete(this.props.uid);
    }
  }, {
    key: "renderAttachmentList",
    value: function renderAttachmentList() {
      return this.props.attachments.map(function (_ref) {
        var id = _ref.id,
            url = _ref.url,
            name = _ref.name;
        return _react2.default.createElement(
          "li",
          { key: id },
          _react2.default.createElement(
            "a",
            { href: url, className: "aclui-comment__attachment" },
            name
          )
        );
      });
    }
  }, {
    key: "renderDeleteConfirmation",
    value: function renderDeleteConfirmation() {
      var _this2 = this;

      if (this.state.showConfirmation) {
        return _react2.default.createElement(
          "div",
          { className: "aclui-comment__confirmation" },
          _react2.default.createElement(
            "h4",
            null,
            this.props.confirmationTitle
          ),
          _react2.default.createElement(
            "p",
            null,
            this.props.confirmationMessage
          ),
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              _Button2.default,
              { type: "destructive", onClick: function onClick() {
                  return _this2.handleOnDelete();
                } },
              this.context.t("actions.delete")
            ),
            _react2.default.createElement(
              _Button2.default,
              { type: "link", onClick: function onClick() {
                  return _this2.setState({ showConfirmation: false });
                } },
              this.context.t("actions.cancel")
            )
          )
        );
      }

      return null;
    }
  }, {
    key: "renderTrashCan",
    value: function renderTrashCan() {
      var _this3 = this;

      if (this.props.canDelete) {
        return _react2.default.createElement(
          "span",
          null,
          _react2.default.createElement(
            _RawButton2.default,
            {
              ariaLabel: this.context.t("comment.delete"),
              className: "trash-wrapper",
              onClick: function onClick() {
                return _this3.setState({ showConfirmation: !_this3.state.showConfirmation });
              }
            },
            _react2.default.createElement(_Icon2.default, { type: "trashbin", size: 18, className: "aclui-comment__trash" })
          ),
          this.renderDeleteConfirmation()
        );
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var className = "aclui-comment\n      " + (this.props.isNewAddedState ? this.isNewAddedStateClassName : "") + "\n      " + (this.props.isDeleteState ? this.isDeleteStateClassName : "");

      return _react2.default.createElement(
        "div",
        { className: className, ref: this.rootElementRendered },
        _react2.default.createElement(_Avatar2.default, { className: "aclui-comment__avatar", userName: this.props.userName }),
        _react2.default.createElement(
          "h4",
          { className: "aclui-comment__title" },
          this.props.userName,
          _react2.default.createElement(
            "span",
            { className: "aclui-comment__timestamp" },
            " - ",
            this.props.timestamp
          )
        ),
        this.renderTrashCan(),
        _react2.default.createElement("div", { className: "aclui-comment__message", dangerouslySetInnerHTML: { __html: this.props.message } }),
        _react2.default.createElement(
          "ul",
          { className: "aclui-comment__container__attachment" },
          this.renderAttachmentList()
        )
      );
    }
  }]);

  return Comment;
}(_react.Component);

var attachmentType = {
  id: _propTypes2.default.number.isRequired,
  name: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired
};

Comment.contextTypes = {
  t: _propTypes2.default.func.isRequired
};

Comment.propTypes = {
  attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape(attachmentType)),
  canDelete: _propTypes2.default.bool,
  confirmationMessage: _propTypes2.default.node,
  confirmationTitle: _propTypes2.default.node,
  isDeleteState: _propTypes2.default.bool,
  isNewAddedState: _propTypes2.default.bool,
  message: _propTypes2.default.node,
  onDelete: _propTypes2.default.func,
  onTransitionEnded: _propTypes2.default.func,
  timestamp: _propTypes2.default.string.isRequired,
  uid: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  userName: _propTypes2.default.string.isRequired
};

Comment.defaultProps = {
  attachments: [],
  canDelete: false,
  confirmationMesssage: "",
  confirmationTitle: "",
  isDeleteState: false,
  isNewAddedState: false,
  message: "",
  onDelete: function onDelete() {},
  onTransitionEnded: function onTransitionEnded() {},
  uid: _uuid2.default.v4()
};

exports.default = Comment;